import type { SavingSettingsDetailsCountryConfig } from './SavingSettingsDetailsConfig';

export const settingsDetails: SavingSettingsDetailsCountryConfig = {
    shouldDisplayCreditInterestRateWithTooltip: true,
    averageSavings: {
        displayAccountOwner: true,
        displaySlashedBBAN: true,
        displayIban: true,
        displayBIC: true,
    },
    termDeposit: {
        displayAccountOwner: true,
        displaySlashedBBAN: true,
        displayIban: true,
        displayBIC: true,
    },
    passbook: {
        displayAccountOwner: true,
        displayIban: true,
        displaySlashedBBAN: true,
        displayBIC: true,
    },
    showAccountProhibitions: true,
};
